import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'update_firmware_external_devices',
    initialState: {},
    reducers: {
        initialUpdate: (state, action) => {
            state[action.payload.device_id] = {
                ...(state[action.payload.device_id] ?? {}),
                show: true,
            };
        },
        progressUpdate: (state, action) => {
            state[action.payload.device_id] = {
                ...action.payload,
                show: true,
            };
        },
        hideUpdate: (state, action) => {
            delete state[action.payload.device_id];
        },
    },
});
export const { progressUpdate, initialUpdate, hideUpdate } = slice.actions;
export const updateIOExtensionFirmwareReducer = slice.reducer;
